.remove-button {
    width: 22px;
}

.remove-button button {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.content-container {
    min-width: 164px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}
